/* eslint-disable */
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { history } from "../../config/stores";
import { setHeaderStatus } from "../../actions";
import News, { findArticleBySlug } from "../../config/NewsText";
import "./styles.scss";

// Helper to get description from article parts
const getArticleDescription = (parts) => {
  if (!parts || parts.length === 0) return "Fidweb - Making software people actually love";
  // Get first text part and strip HTML tags
  const firstPart = parts[0];
  const stripped = firstPart.replace(/<[^>]*>/g, '').replace(/className='[^']*'/g, '');
  // Truncate to 160 characters for meta description
  return stripped.length > 160 ? stripped.substring(0, 157) + "..." : stripped;
};

// Helper to get absolute image URL
const getAbsoluteImageUrl = (image) => {
  if (!image) return "https://fidweb.net/screenshot.png";
  // If it's already an absolute URL, return it
  if (image.startsWith('http')) return image;
  // Otherwise, construct the full URL
  return `https://fidweb.net${image}`;
};

// Helper to convert className to class for HTML rendering
const convertToHtml = (htmlString) => {
  if (!htmlString) return htmlString;
  return htmlString.replace(/className=/g, 'class=');
};

const Article = ({ setHeaderStatus }) => {
  const isMobileVersion = window.innerWidth < 900 ? 1 : 0;
  
  // Get slug from URL path: /article/slug-here
  const slug = window.location.pathname.split("/")[2];
  
  // Find article by slug, fallback to index for backward compatibility
  let article = findArticleBySlug(slug);
  let articleIndex = article ? article.index : null;
  
  // Backward compatibility: if slug is a number, use it as index
  if (!article && !isNaN(parseInt(slug))) {
    articleIndex = parseInt(slug);
    article = News[articleIndex];
  }
  
  // Fallback to empty object if not found
  if (!article) {
    article = {};
  }

  useEffect(() => {
    if (window.innerWidth > 900) {
      const footer = document.getElementById("footer");
      if (footer) {
        footer.classList.add("disable");
        footer.style.display = "none";
      }
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  // Get article data safely
  const articleTitle = article.title || "Fidweb Article";
  const articleDescription = getArticleDescription(article.parts);
  const articleImage = getAbsoluteImageUrl(article.image);
  const articleUrl = `https://fidweb.net/article/${article.slug || slug}`;

  return (
    <>
      <Helmet>
        <title>{articleTitle} | Fidweb</title>
        <meta name="description" content={articleDescription} />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="article" />
        <meta property="og:url" content={articleUrl} />
        <meta property="og:title" content={articleTitle} />
        <meta property="og:description" content={articleDescription} />
        <meta property="og:image" content={articleImage} />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={articleUrl} />
        <meta name="twitter:title" content={articleTitle} />
        <meta name="twitter:description" content={articleDescription} />
        <meta name="twitter:image" content={articleImage} />
      </Helmet>
      
      {isMobileVersion === 1 ? (
        <>
          <div className="mobile-article-container">
            <div
              className="mobile-arrow-left"
              onClick={() => {
                history.push("/news");
                setHeaderStatus("Software Development");
                const footer = document.getElementById("footer");
                if (footer) footer.classList.remove("disable");
              }}
            />
            <div className="mobile-neshto" style={{ paddingBottom: "20px" }}>
              {article.logo && (
                <div
                  className="logo"
                  style={{
                    backgroundImage: `url(${article.logo})`,
                  }}
                />
              )}
              <img 
              src={article.image}
              />
              <h3 style={{ fontSize: "20px", marginLeft: "6%", marginTop: "2%" }}>{article.title}</h3>

              {article.parts && article.parts.map((part) => {
                return article.html ? <div className={`mobile-article-text ${part.includes("no-padding") ? "no-padding" : ""} ${part.includes("no-margin") ? "no-margin" : ""} ${part.includes("bulletpoint") ? "bulletpoint" : ""}`} dangerouslySetInnerHTML={{ __html: convertToHtml(part) }}></div> : <div className="mobile-article-text">{part}</div>;
              })}
              <div className={`icons-container ${article?.images ? "images-logos" : ""}`}>
              {article.apple && <div className={`apple-icon ${article.title?.includes("Scoutify") && "scoutify"}`} onClick={() => window.open(article.apple)} />}
                {article.play && <div className={`play-icon ${article.title?.includes("Scoutify") && "scoutify"}`} onClick={() => window.open(article.play)} />}
                {article.site && <div className="site-icon" onClick={() => window.open(article.site)} />}
                {article?.images &&
                  article?.images?.map((el, index) => {
                    return <div className={`logo-icon-${el.logo}`} onClick={() => window.open(el?.link)} />;
                  })}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="article-container">
          <div className="left-article-container">
            <div
              className="arrow-left"
              onClick={() => {
                history.push("/");
                setHeaderStatus("Software Development");
                const footer = document.getElementById("footer");
                if (footer) footer.classList.remove("disable");
              }}
            />
            <div className="neshto">
              {article.logo && (
                <div
                  className="logo"
                  style={{
                    backgroundImage: `url(${article.logo})`,
                  }}
                />
              )}

              <h2>{article.title}</h2>

              {article.parts && article.parts.map((part, partIndex) => {
                return article.html ? (
                  <div className={`article-text ${part.includes("no-padding") ? "no-padding" : ""} ${part.includes("no-margin") ? "no-margin" : ""} ${part.includes("bulletpoint") ? "bulletpoint" : ""} ${part.includes("medium") ? "medium" : ""} ${part.includes("last") ? "last" : ""}`} dangerouslySetInnerHTML={{ __html: convertToHtml(part) }}></div>
                ) : article?.video && partIndex === 2 ? (
                  <>
                    <div
                      className="video-image video"
                      onClick={() => {
                        window.open(article?.video);
                      }}
                    />

                    <div className="article-text">{part}</div>
                  </>
                ) : (
                  <div className="article-text">{part}</div>
                );
              })}
              <div className={`icons-container ${article?.images ? "images-logos" : ""}`}>
                {article.apple && <div className={`apple-icon ${article.title?.includes("Scoutify") && "scoutify"}`} onClick={() => window.open(article.apple)} />}
                {article.play && <div className={`play-icon ${article.title?.includes("Scoutify") && "scoutify"}`} onClick={() => window.open(article.play)} />}
                {article.site && <div className="site-icon" onClick={() => window.open(article.site)} />}
                {article?.images &&
                  article?.images?.map((el, index) => {
                    return <div className={`logo-icon-${el.logo}`} onClick={() => window.open(el?.link)} />;
                  })}
              </div>
            </div>
          </div>
          <div
            className="right-article-container"
            style={{
              backgroundPosition: article.resize ? 'unset' : 'center',
              backgroundImage: `url(${article.image})`,
              backgroundSize: article.special ? "100%" : article.html && (window.innerWidth > 1200 ? "cover" : "contain"),
            }}
          ></div>
        </div>
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  headerStatus: state.stateControl.headerStatus,
});

const mapDispatchToProps = (dispatch) => ({
  setHeaderStatus: (payload) => dispatch(setHeaderStatus(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Article);
